import moment from "moment";
import ShowRevisionServires from "@/services/ShowRevisionServices";
import { maxOrderIdPlusPlus, generateUUID } from "@/services/GlobalServices";
import DashboardInternalData from "@/internalData/Dashboard";
import _ from "lodash";

const freezeMaxIdOrder = (state) => {
  const result = {};
  const listTableOnDashboard = [
    "workRecords",
    "inspections",
    "carryingIO",
    "safetyPlans",
    "safetyPlanImprovementPlans",
    "co2InSiteWork",
    "co2OutSiteWork",
  ];
  for (const attr of listTableOnDashboard) {
    const maxOrderRecord =
      parseInt(maxOrderIdPlusPlus(state.revisions[attr])) - 1;
    _.set(result, attr, maxOrderRecord);
  }
  if (state.revisions["workRecords"]) {
    state.revisions["workRecords"].forEach((workRecord) => {
      // workRecordのデータ構造を確認（record.qualificatedResponsible または qualificatedResponsible）
      const qualificatedResponsibleList = workRecord.record?.qualificatedResponsible || workRecord.qualificatedResponsible || [];
      const equipmentsList = workRecord.record?.equipments || workRecord.equipments || [];
      const safetyInstructionsList = workRecord.record?.safetyInstructions || workRecord.safetyInstructions || [];
      
      
      const maxOrderQualificatedResponsible =
        parseInt(maxOrderIdPlusPlus(qualificatedResponsibleList)) - 1;
      const maxOrderEquipment =
        parseInt(maxOrderIdPlusPlus(equipmentsList)) - 1;
      const maxOrderSafetyInstruction =
        parseInt(maxOrderIdPlusPlus(safetyInstructionsList)) - 1;
      _.set(
        result,
        ["workRecordsQualifiedResponsible", workRecord.order],
        maxOrderQualificatedResponsible
      );
      _.set(
        result,
        ["workRecordsEquipments", workRecord.order],
        maxOrderEquipment
      );
      _.set(
        result,
        ["workRecordsSafetyInstructions", workRecord.order],
        maxOrderSafetyInstruction
      );
    });
  }
  return result;
};
const formatDataStructWorkRecord = (diaries) => {
  const result = _.cloneDeep(diaries);
  diaries.forEach((diary, diariesID) => {
    diary.workRecords.forEach((workRecord, workRecordID) => {
      const record = workRecord.record;
      //change qualificatedResponsible obj to arr
      if (record.qualificatedResponsible.length == undefined) {
        _.set(
          result,
          [
            diariesID,
            "workRecords",
            workRecordID,
            "record",
            "qualificatedResponsible",
          ],
          []
        );
        _.set(
          result,
          [
            diariesID,
            "workRecords",
            workRecordID,
            "record",
            "qualificatedResponsible",
            0,
            "order",
          ],
          0
        );
        _.set(
          result,
          [
            diariesID,
            "workRecords",
            workRecordID,
            "record",
            "qualificatedResponsible",
            0,
            "record",
          ],
          record.qualificatedResponsible
        );
      }
      //move confirmed to first item safetyInstructions
      if (_.has(record, "confirmed")) {
        _.set(
          result,
          [
            diariesID,
            "workRecords",
            workRecordID,
            "record",
            "safetyInstructions",
            0,
            "record",
            "confirmed",
          ],
          record.confirmed
        );
      }
    });
  });
  return normalizeDuplicateOrders(result);
};
// order で行を対応付けるテーブル（作業記録は orderPosition / originalRowId を併用するため対象外）
const ORDERED_RECORD_TABLES = [
  "inspections",
  "carryingIORecords",
  "safetyPlans",
  "safetyPlanImprovementPlans",
];
/**
 * 同じリビジョン内で order が重複している行に、末尾の番号を振り直す。
 * 画面側は order で行を探すため（finOrderIndex は最初の 1 件しか返さない）、
 * 重複があると 2 行目が order を持たない空行として送信され、保存が 400 で失敗し続ける。
 * 過去の不具合で重複したまま保存されたデータを、読み込み時に救済する。
 */
const normalizeDuplicateOrders = (diaries) => {
  for (const diary of diaries) {
    for (const table of ORDERED_RECORD_TABLES) {
      const records = diary[table];
      if (!Array.isArray(records)) continue;
      const seen = new Set();
      let maxOrder = _.max(records.map((r) => Number(r.order)).filter(Number.isFinite));
      for (const r of records) {
        if (r.order == undefined) continue;
        if (seen.has(Number(r.order))) {
          maxOrder = (maxOrder ?? -1) + 1;
          r.order = maxOrder;
          if (r.record && r.record.orderPosition !== undefined) {
            r.record.orderPosition = maxOrder;
          }
        }
        seen.add(Number(r.order));
      }
    }
  }
  return diaries;
};
const formatOutSiteWorkData = (record) => {
  const outSiteWorkTemp = record;
  const outSiteWork = {};
  outSiteWork["outSiteWork"] = {
    order: outSiteWorkTemp.order,
    machineType: outSiteWorkTemp.machineType,
    number: outSiteWorkTemp.number,
    loadCapacity: outSiteWorkTemp.loadCapacity,
    loadCapacityTrash: outSiteWorkTemp.loadCapacityTrash,
    transportDistance: outSiteWorkTemp.transportDistance,
  };
  return outSiteWork;
};
const formatInputAPI = (records) => {
  const result = [];
  for (const i in records) {
    const r = records[i];
    const item = { record: { ...r } };
    if (r.order != undefined) {
      // orderPositionが存在する場合はそれを優先して使用（作業記録の順序変更対応）
      item["order"] = r.orderPosition !== undefined ? r.orderPosition : r.order;
    }
    
    // orderPositionをrecord内に保持（Backendで必須のため）
    if (r.orderPosition !== undefined) {
      item["record"].orderPosition = r.orderPosition;
    } else if (r.order !== undefined) {
      item["record"].orderPosition = r.order;
    }
    
    // originalRowIdをrecord内に保持（差分表示改善のため）
    if (r.originalRowId !== undefined) {
      item["record"].originalRowId = r.originalRowId;
    }
    
    //delete trash attribute
    delete item["record"].isFocus;
    delete item["record"].previousItem;
    delete item["record"].style;
    delete item["record"].order;
    delete item["record"].qualificationData; // UI表示用のフィールドなのでAPI送信時は削除
    // order も中身も持たない行は、画面の差分計算で生じた空行なので送らない。
    // 送ると Backend の order 必須デコードで 400 になり、日誌全体が保存できなくなる。
    if (item["order"] === undefined && _.isEmpty(item["record"])) {
      continue;
    }
    result.push(item);
  }
  return result;
};
//delete diaries appear before copy diary to
const deleteDiariesBeforeCopy = (diaries, diaryId) => {
  let resourceDiaries = _.cloneDeep(diaries);
  const result = [];
  const diaryCurrentView = _.find(diaries, (diary) => {
    return diary.diaryId == diaryId;
  });
  resourceDiaries.sort((revisionBefore, revisionAfter) => {
    return -(revisionBefore.revision - revisionAfter.revision);
  });
  resourceDiaries = _.filter(resourceDiaries, function (diary) {
    return diary.revision <= diaryCurrentView.revision;
  });

  for (const revision of resourceDiaries) {
    result.push(revision);
    if (revision.copied) {
      break;
    }
  }
  return result;
};

const serializerDiary = (diary, siteId, typeEdit, fromDiaryList = false) => {
  let resultDiary = {};

  // 楽観的ロック用のリビジョン番号
  if (diary.revision) {
    resultDiary["expectedRevision"] = diary.revision;
  }

  resultDiary["attachedImageUrl"] = diary.attachedImageUrl;
  resultDiary["attachedImagePresignedUrl"] = diary.attachedImagePresignedUrl;
  resultDiary["attachedImageObjectKey"] = diary.attachedImageObjectKey;
  resultDiary["diaryDate"] = moment(diary.diaryDate).format("YYYY-MM-DD");
  resultDiary["diaryPeriod"] = diary.diaryPeriod;
  resultDiary["siteId"] = siteId;
  resultDiary["editDateTime"] = moment(new Date()).toISOString(true);
  resultDiary["editor"] = diary.editor;
  resultDiary["state"] = diary.state;
  resultDiary["editAs"] = typeEdit;
  resultDiary["weather"] = diary.weather;
  resultDiary["temperature"] = diary.temperature;
  resultDiary["windSpeed"] = diary.windSpeed;
  resultDiary["meetingDateTime"] = moment(diary.meetingDateTime).toISOString(
    true
  );
  resultDiary["responsibleOfSafe"] = diary.responsibleOfSafe;
  resultDiary["signs"] = _.cloneDeep(diary.signs);

  //co2Input
  resultDiary["co2"] = { inSiteWork: [], outSiteWork: [] };
  // insiteSiteWork
  for (const i in diary.co2InSiteWork) {
    const inSiteWorkTemp = diary.co2InSiteWork[i];
    const inSiteWork = {};
    inSiteWork["inSiteWork"] = {
      order: inSiteWorkTemp.order,
      machineOwner: inSiteWorkTemp.machineOwner,
      machine: inSiteWorkTemp.machine,
      oldMachineFirstLayer: inSiteWorkTemp.oldMachineFirstLayer,
      oldMachineSecondLayer: inSiteWorkTemp.oldMachineSecondLayer,
      oldMachineThirdLayer: inSiteWorkTemp.oldMachineThirdLayer,
      budget: inSiteWorkTemp.budget,
      actual: inSiteWorkTemp.actual,
    };
    resultDiary["co2"].inSiteWork.push(inSiteWork);
  }
  // outsiteSiteWork
  if (!fromDiaryList) {
    // for (const i in diary.co2OutSiteWork) {
    //     const outSiteWorkTemp = diary.co2OutSiteWork[i];
    //     const outSiteWork = formatOutSiteWorkData(outSiteWorkTemp);
    //     resultDiary["co2"].outSiteWork.push(outSiteWork);
    // }
  }
  for (const i in diary.co2OutSiteWorkWaste) {
    const outSiteWorkTemp = diary.co2OutSiteWorkWaste[i];
    const outSiteWork = formatOutSiteWorkData(outSiteWorkTemp);
    resultDiary["co2"].outSiteWork.push(outSiteWork);
  }
  for (const i in diary.co2OutSiteWorkContructionSoil) {
    const outSiteWorkTemp = diary.co2OutSiteWorkContructionSoil[i];
    const outSiteWork = formatOutSiteWorkData(outSiteWorkTemp);
    resultDiary["co2"].outSiteWork.push(outSiteWork);
  }
  // inspections
  for (const nameRecord of [
    "workRecords",
    "inspections",
    "carryingIORecords",
    "safetyPlans",
    "safetyPlanImprovementPlans",
  ]) {
    if (nameRecord == "carryingIORecords") {
      resultDiary[nameRecord] = formatInputAPI(diary["carryingIO"]);
    } else {
      resultDiary[nameRecord] = formatInputAPI(diary[nameRecord]);
    }
  }
  //set equipments and safetyInstructions
  for (const i in resultDiary["workRecords"]) {
    const record = resultDiary["workRecords"][i].record;
    // Backend の WorkRecordRecordDto が必須扱いする文字列フィールドは
    // 片方だけ編集された行で JSON から欠落するケースがあり、保存時に 400 になる。
    // ここで常に空文字でプレースホルドして送信する (Issue #892)。
    if (record.primaryConstractor === undefined || record.primaryConstractor === null) {
      record.primaryConstractor = "";
    }
    if (record.subContractor === undefined || record.subContractor === null) {
      record.subContractor = "";
    }
    if (record.workType === undefined || record.workType === null) {
      record.workType = "";
    }
    if (record.workDescription === undefined || record.workDescription === null) {
      record.workDescription = "";
    }
    if (record.sign === undefined || record.sign === null) {
      record.sign = "";
    }
    if (record.presignedUrl === undefined || record.presignedUrl === null) {
      record.presignedUrl = "";
    }

    resultDiary["workRecords"][i].record.qualificatedResponsible =
      formatInputAPI(
        resultDiary["workRecords"][i].record.qualificatedResponsible
      );
    resultDiary["workRecords"][i].record.equipments = formatInputAPI(
      resultDiary["workRecords"][i].record.equipments
    );
    
    // safetyInstructions のうち実体のない行を除外する (Issue #909)。
    // type は UI で未選択のとき null になり得る。null を空とみなさないと
    // フィルタ条件 (type !== "") をすり抜けて空行が残り、その null が
    // Backend の String 必須デコーダで 400 を起こす。
    // 値そのものの正規化は行わない: null/欠落は Backend 側 (SafetyInstructionDto)
    // がデフォルトへフォールバックする (type→"safety" / instruction→"") ため、
    // フロントで別の既定値("")へ寄せると分類(安全/品質・環境)が経路により食い違う。
    const filteredSafetyInstructions = resultDiary["workRecords"][i].record.safetyInstructions.filter(instruction => {
      // type / instruction が実値を持つ、または confirmed が true の行のみ残す
      const hasType = instruction.type != null && instruction.type !== "";
      const hasInstruction = instruction.instruction != null && instruction.instruction !== "";
      return hasType || hasInstruction || instruction.confirmed === true;
    });
    
    resultDiary["workRecords"][i].record.safetyInstructions = formatInputAPI(
      filteredSafetyInstructions
    );
  }
  // sitePatrolRecords
  resultDiary["sitePatrolRecords"] = [];
  for (const sitePatrol of diary.sitePatrolRecords) {
    for (const site of sitePatrol.site) {
      resultDiary["sitePatrolRecords"].push(site);
    }
  }
  resultDiary["commonInstructions"] = diary.commons.commonInstructions;
  resultDiary["environmentalManagementInstructions"] =
    diary.commons.environmentalManagementInstructions;
  resultDiary["instructionDuringWork"] = _.cloneDeep(
    diary.commons.instructionDuringWork
  );
  // 作業中の指示情報のinstructorフィールドに、instructorObjectKeyの値を設定
  if (diary.commons.instructionDuringWork.instructorObjectKey) {
    resultDiary["instructionDuringWork"]["instructor"] =
      diary.commons.instructionDuringWork.instructorObjectKey;
  }

  resultDiary["supervisorPatrolRecord"] = _.cloneDeep(
    diary.commons.supervisorPatrolRecord
  );
  // 監督者パトロール記録のsupervisorフィールドに、supervisorObjectKeyの値を設定
  if (diary.commons.supervisorPatrolRecord.supervisorObjectKey) {
    resultDiary["supervisorPatrolRecord"]["supervisor"] =
      diary.commons.supervisorPatrolRecord.supervisorObjectKey;
  }
  // convert PresignedURl to S3URl for save data
  // for(const i in resultDiary["signs"]){
  //   resultDiary["signs"][i].sign.name = resultDiary["signs"][i].sign.S3Url;
  // }
  // resultDiary["instructionDuringWork"]["instructor"]= resultDiary.instructionDuringWork.S3Url;
  // resultDiary["supervisorPatrolRecord"]["supervisor"] = resultDiary.supervisorPatrolRecord.S3Url;
  
  // workRecordsのobjectKeyフィールドをsignフィールドに設定
  resultDiary["workRecords"].forEach(item => {
    if (item.record.objectKey) {
      item.record.sign = item.record.objectKey;
    }
  });
  
  // resultDiary["attachedImagePresignedUrl"] = diary.attachedImagePresignedUrl;
  return resultDiary;
};
const defaultWorkRecord = () => {
  const styleQualificatedResponsible = ShowRevisionServires.createTemplate(
    "workRecordsQualifiedResponsible"
  );
  const recordQualificatedResponsible =
    ShowRevisionServires.createTemplatePreviousValue(
      "workRecordsQualifiedResponsible"
    );
  const styleEquipment = ShowRevisionServires.createTemplate(
    "workRecordsEquipments"
  );
  const recordEquipment = ShowRevisionServires.createTemplatePreviousValue(
    "workRecordsEquipments"
  );
  const styleSafetyInstruction = ShowRevisionServires.createTemplate(
    "workRecordsSafetyInstructions"
  );
  const recordSafetyInstruction =
    ShowRevisionServires.createTemplatePreviousValue(
      "workRecordsSafetyInstructions"
    );
  const uuid = generateUUID();
  return {
    order: -1,
    originalRowId: uuid, // 新規作業記録作成時にUUIDを生成
    primaryConstractor: "",
    subContractor: "",
    workType: "",
    workDescription: "",
    sign: "",
    presignedUrl: "",
    objectKey: "",
    contractCompanyId: null,
    qualificatedResponsible: [
      {
        order: 0,
        qualification: "",
        name: "",
        qualificationId: null,
        qualificationData: null,
        style: styleQualificatedResponsible,
        previousItem: recordQualificatedResponsible,
      },
    ],
    numberOfPeople: {
      budget: null,
      actual: null,
    },
    equipments: [
      {
        order: 0,
        type: "",
        subType: "",
        number: "",
        unit: "台",
        style: styleEquipment,
        previousItem: recordEquipment,
      },
    ],
    safetyInstructions: [
      {
        order: 0,
        type: "",
        instruction: "",
        confirmed: null,
        style: styleSafetyInstruction,
        previousItem: recordSafetyInstruction,
      },
    ],
    useOfFire: false,
  };
};
const defaultDiaryRevision = (typeEdit = "budget") => {
  const defaultDiary = {
    editAs: typeEdit,
    diaryDate: moment(new Date()),
    diaryPeriod: "daytime",
    editDateTime: moment(new Date()),
    weather: "",
    state: "",
    editor: "",
    temperature: {
      highest: "",
      lowest: "",
    },
    windSpeed: {
      speed: "",
      unit: "m",
    },
    responsibleOfSafe: "",
    meetingDateTime: moment(new Date()),
    signs: [
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 1,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 2,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 3,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 4,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 5,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 6,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 7,
      },
      {
        sign: {
          presignedUrl: "",
          name: "",
          jobTitle: "",
          objectKey: "",
        },
        order: 8,
      },
    ],
    sitePatrolRecords: _.cloneDeep(DashboardInternalData.sitePatrolRecords),
    commons: {
      commonInstructions: "",
      environmentalManagementInstructions: "",
      instructionDuringWork: {
        instruction: "",
        instructor: "",
        instructorPresignedUrl: "",
        instructorObjectKey: "",
      },
      supervisorPatrolRecord: {
        record: "",
        supervisor: "",
        supervisorPresignedUrl: "",
        supervisorObjectKey: "",
      },
      hideRevision: true,
      isFocus: {
        instructionDuringWork: {},
        supervisorPatrolRecord: {},
      },
      style: {
        commonInstructions: "",
        environmentalManagementInstructions: "",
        instructionDuringWork: {
          instruction: "",
          instructor: "",
          instructorPresignedUrl: "",
          instructorObjectKey: "",
        },
        supervisorPatrolRecord: {
          record: "",
          supervisor: "",
          supervisorPresignedUrl: "",
          supervisorObjectKey: "",
        },
      },
      previousItem: {
        instructionDuringWork: {},
        supervisorPatrolRecord: {},
      },
    },
    attachedImageUrl: "",
    attachedImagePresignedUrl: "",
    attachedImageObjectKey: "",
    workRecords: [],
    inspections: [],
    carryingIO: [],
    safetyPlans: [],
    safetyPlanImprovementPlans: [],
    co2InSiteWork: [],
    co2OutSiteWork: [],
    co2OutSiteWorkWaste: [],
    co2OutSiteWorkContructionSoil: [],
  };
  return defaultDiary;
};
const convertObjToArrCo2Input = (layerOptions, filterOptions) => {
  const objTemp = _.cloneDeep(layerOptions);
  //change option layerOption to filterOptions
  const resultTemp = _.map(objTemp, (firstElement, firstKey) => {
    return {
      key: firstKey,
      label: firstElement.name,
      items: _.map(firstElement.items, (secondElement, secondKey) => {
        return {
          key: secondKey,
          label: secondElement.name,
          items: _.map(secondElement.items, (thirdElement, thirdKey) => {
            return {
              key: thirdKey,
              label: thirdElement.name,
            };
          }),
        };
      }),
    };
  });
  resultTemp.sort((item, nextItem) => {
    return (
      parseInt(item.key.substr(0, 2)) - parseInt(nextItem.key.substr(0, 2))
    );
  });
  //add entry group element, and save position index
  const positionGroupElements = [0];
  const results = [];
  results.push({ key: resultTemp[0].key.substr(0, 2), label: null });
  resultTemp.forEach((result, index) => {
    results.push(result);
    if (index != resultTemp.length - 1) {
      const nextKey = resultTemp[index + 1].key;
      if (result.key.substr(0, 2) != nextKey.substr(0, 2)) {
        results.push({ key: nextKey.substr(0, 2), label: null });
        const indexGroupLablel = index + 2 + positionGroupElements.length - 1;
        positionGroupElements.push(indexGroupLablel);
      }
    }
  });
  //map with filter
  for (let indexGroup in positionGroupElements) {
    const positionGroup = positionGroupElements[indexGroup];
    let nameGroup = "";
    for (let filterKey in filterOptions) {
      if (filterOptions[filterKey] == results[positionGroup].key) {
        nameGroup = filterKey;
        break;
      }
    }
    //add search name
    let labelGroup = "";
    if (indexGroup != positionGroupElements.length - 1) {
      const positionGroupNext = positionGroupElements[parseInt(indexGroup) + 1];
      for (
        let startPosition = positionGroup + 1;
        startPosition <= positionGroupNext - 1;
        startPosition++
      ) {
        labelGroup += results[startPosition].label;
      }
    } else {
      for (
        let startPosition = positionGroup + 1;
        startPosition < results.length;
        startPosition++
      ) {
        labelGroup += results[startPosition].label;
      }
    }
    results[positionGroup].group = nameGroup;
    results[positionGroup].label = labelGroup;
  }
  return results;
};
const isImageBaseURL = (sign) => {
  // HTTPSのURLとオブジェクトURL（blob:）とデータURL（data:）をサポート
  const imagePrefixes = ["http://", "https://", "blob:", "data:"];
  if (sign && sign.length > 30) {
    for (const prefix of imagePrefixes) {
      if (sign.includes(prefix)) {
        return true;
      }
    }
  }
  return false;
};
/**
 * 競合時のマージ: ローカルの workRecords から自分が追加した分を特定する
 * @param {Array} localWorkRecords - 現在のローカル workRecords
 * @param {Array} loadedOriginalRowIds - ロード時に存在していた originalRowId の一覧
 * @returns {Array} 自分が追加した workRecords
 */
const extractLocalAdditions = (localWorkRecords, loadedOriginalRowIds) => {
  if (!localWorkRecords || !loadedOriginalRowIds) return [];
  const loadedSet = new Set(loadedOriginalRowIds);
  return localWorkRecords.filter(wr => {
    const rowId = wr.originalRowId;
    return rowId && !loadedSet.has(rowId);
  });
};

export default {
  freezeMaxIdOrder,
  defaultWorkRecord,
  defaultDiaryRevision,
  deleteDiariesBeforeCopy,
  serializerDiary,
  formatDataStructWorkRecord,
  normalizeDuplicateOrders,
  convertObjToArrCo2Input,
  isImageBaseURL,
  extractLocalAdditions,
};
